<template>
    <div  >

        <!-- quest explore -->
        <tq-card width="100%"  max-width="350px" margin="8px">

            <tq-quest-explore-header
                :pb_quest-explore_c="p_questExplore_c"
                :pb_quest-explore-info_c="p_questExploreInfo_c"
                :pb_created-user-data_c="p_createdUserData_c"

                :p_system_current-currency_e="p_currency_e"
                :ps_lang-code_e="p_system_langCode_e"
                :ps_screen-size_en="p_screenSize_en"

                :p_always-show-slider_b="true"
                :pf_small-mode_b="true"
                :pf_display-active-status_b="true"
            />
        </tq-card>

        <!-- reviews -->
        <div class="TQ_maxWidth_550px TQ_border TQ_borderRadius TQ_inline TQ_width_100p TQ_margin_8px">

            <!-- title-->
            <div class="TQ_padding_8px TQ_text_20px TQ_bg_purple_dark">
                {{ass_strings.oneWord_reviews[p_system_langCode_e]}}
            </div>


            <div v-if="p_questReviews_ac.length > 0">
                <!-- reviews -->
                <div v-for="questReview_c in p_questReviews_ac" class="TQ_padding_8px ">

                    <div class="TQ_grid_col_auto1fr TQ_grid_gap_16px"
                         v-if="p_userData_byUserId_c[questReview_c.qr_reviewerId_uid]">

                        <div class="TQ_width_72px TQ_grid_center TQ_center">

                            <fcc-avatar :p_ud_avatar_c="p_userData_byUserId_c[questReview_c.qr_reviewerId_uid].ud_avatar_c"
                                        :key="$options.name + questReview_c.qr_reviewerId_uid"
                                        class="TQ_width_44px TQ_borderRadius TQ_center"/>


                            <div class="TQ_verticalAlignMiddle TQ_text_12px TQ_text_wordWrap">{{p_userData_byUserId_c[questReview_c.qr_reviewerId_uid].ud_name_s}} </div>
                        </div>

                        <div class="TQ_textAlign_initial TQ_grid_row_auto1frAuto ">

                            <div class="TQ_grid_col_1frAutoAuto">
                                <si_-stars :rating="questReview_c.qr_overallRating_n" class="TQ_grid_verticalCenter"/>

                                <tq-image class="TQ_width_32px TQ_padding_4px TQ_center TQ_grid_verticalCenter" :pb_src_r="helper_getDiffLevel_o(questReview_c.qr_difficulty_n, p_system_langCode_e).img_r" pb_att_s="diffLevel TQ" />

                                <tq-dropdown options-width="100px" :show-caret-down="false" class="TQ_width_24px TQ_grid_verticalCenter TQ_margin_-4px">

                                    <tq-image slot="select"  :pb_src_r="ass_three_dots" pb_att_s="review option"/>

                                    <div @click="() => {showPopup_reportReview_vb.val=true; reportReviewText_s=null; reportReviewReviewerId_uid=questReview_c.qr_reviewerId_uid}"
                                         slot="options" class="TQ_padding_8px TQ_text_14px TQ_bg_gray4 TQ_bg_hover_goldLite">
                                        {{ass_strings.oneWord_report[p_system_langCode_e]}}
                                    </div>

                                </tq-dropdown>
                            </div>

                            <div class="TQ_text_selectable TQ_text_bold"> {{ass_strings.twoWords_publicFeedback[p_system_langCode_e] }}: </div>
                            <div class="TQ_text_selectable"> {{questReview_c.qr_publicFeedback_s}}</div>
                            <div class="TQ_text_selectable TQ_text_bold"> {{ass_strings.twoWords_privateFeedback[p_system_langCode_e]}}: </div>
                            <div class="TQ_text_selectable"> {{questReview_c.qr_privateFeedback_n}}</div>
                            <div class="TQ_text_12px TQ_textAlign_end">{{format_date_YYYY_MM_DD_fs(questReview_c.qr_timestamp_t)}} </div>
                        </div>
                    </div>
                    <hr>
                </div>

                <!-- btns -->
                <tq-loader-button :show-loader="p_showMoreReviewsBtnLoader_b" v-if="!p_getAllReviews_b">
                    <div @click="pe_reviews_getNext3_f" class="TQ_text_capitalize TQ_padding_8px">
                        <div class="TQ_inline TQ_bg_purple TQ_padding_8px TQ_clickable TQ_borderRadius">
                            show more reviews
                        </div>
                    </div>
                </tq-loader-button>
            </div>
            <div v-else class="TQ_padding_16px TQ_text_20px TQ_text_capitalize">
                {{ ass_strings.twoWords_noReviews[p_system_langCode_e] }}
            </div>


        </div>
    </div>
</template>

<script>
import {
    validator_arrayClass_fb,
    validator_enum_fb,
    validator_objClass_fb
} from "../../../../../functions/src/shareCode/Share_S_Validator";
import {FB_QuestReview, FB_UserData} from "../../../../../functions/src/shareCode/Share_S_Classes";
import {
    enum_costCurrency_n,
    enum_langCodes,
} from "../../../../../functions/src/shareCode/Share_S_Enum";
import TqQuestExploreHeader from "@/components/complex/TqQuestExploreHeader";
import Si_Stars from "@/components/a_smartIcons/si_Stars";
import TqCard from "@/components/basic/TqCard";
import {helper_getDiffLevel_o} from "@/scripts/S_Helper";
import TqDropdown from "@/components/basic/TqDropdown";
import {format_date_YYYY_MM_DD_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
import {ass_img_threeDots} from "@/assets/scripts/Ass_Files";
import FccAvatar from "@/components/complex/TqAvatar";
import TqImage from "@/components/basic/TqImage";
import TqLoaderButton from "@/components/basic2/TqLoaderButton";

export default {
    name: "c_Creator_EditQuests_Item_Overview",
    components: {TqLoaderButton, TqImage, FccAvatar, TqDropdown, TqCard, Si_Stars, TqQuestExploreHeader},
    props:{

        p_screenSize_en:{},
        p_questExplore_c : {},
        p_questExploreInfo_c:{},
        p_createdUserData_c: {},

        p_questReviews_ac : {
            type: Array,
            require: true,
            validator(val){
                return validator_arrayClass_fb(val, FB_QuestReview)
            }
        },
        p_system_langCode_e : {
            type: String,
            require: true,
            validator(val){
                return validator_enum_fb(enum_langCodes, val)
            }
        },
        p_currency_e : {
            type: Number,
            require: true,
            validator(val){
                return validator_enum_fb(enum_costCurrency_n, val)
            }
        },
        p_showMoreReviewsBtnLoader_b: {
            type: Boolean,
            require: true,
        },
        p_getAllReviews_b: {
            type: Boolean,
            require: true,
        },
        p_userData_byUserId_c:{
            type: Object,
            require: true,
            validator(val){
                return validator_objClass_fb(val, FB_UserData)
            }
        },

        pe_reviews_getNext3_f : {
            type: Function,
            require: true
        }
    },
    data(){
        return {
            helper_getDiffLevel_o : helper_getDiffLevel_o,
            format_date_YYYY_MM_DD_fs : format_date_YYYY_MM_DD_fs,
            ass_strings : ass_strings,
            ass_three_dots : ass_img_threeDots,
        }
    }
}
</script>

<style scoped>
    .lc_test{
        background: green;
    }
</style>